import { ApiSlugs, ListPagination, NotificationDto, NotificationId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserNotificationsAdminConnector extends ApiConnector<
  NotificationDto,
  NotificationDto,
  NotificationId
> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.NOTIFICATIONS}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<NotificationDto[]> =>
      this.apiCaller.getRequest<NotificationDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
